<template>
  <div class="formBox">
    <div class="cont">
      <div class="item">
        <div class="lable">班组：</div>
        <el-select v-model="value1" @change="teamsChange" size="small" class="input" filterable placeholder="请选择">
          <el-option
            v-for="item in options1"
            :key="item.idcard"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <div class="lable">身份证：</div>
        <el-select v-model="value" @change="dataCha" size="small" class="input" filterable placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.idcard"
            :label="item.idcard+'('+ item.name+')'"
            :value="item.idcard">
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <div class="lable">姓名：</div>
        <el-input disabled v-model="name" size="small" class="input" placeholder="请输入内容"></el-input>
      </div>
      <div class="item">
        <div class="lable">时间：</div>
        <el-date-picker
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="dateCha"
        size="small" class="input"
          v-model="date"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
      <div class="item">
        <div class="lable">进出类型：</div>
        <el-select v-model="type" @change="typeCha" size="small" class="input" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <div class="lable">考勤机：</div>
        <el-select v-model="idValue" size="small" class="input" filterable placeholder="请选择">
          <el-option
            v-for="item in idList"
            :key="item.id"
            :label="item.id"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <div class="lable">图片：</div>
        <el-upload
          class="avatar-uploader"
          :action="upUrl"
          :data="{type:265}"
          :headers="uploadHead"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <el-button :disabled="!lock" style="margin-left: 75px;margin-top: 79px;" type="primary" size="medium" @click="shangchuan">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
  export default {
    data() {
      return {
        value:'',
        value1:'',
        options:[],
        options1:[],
        imageUrl: '',
        name:'',
        value1:'',
        date:'',
        type:'',
        typeList:[
          {
            name:'进',
            value:'0'
          },
          {
            name:'出',
            value:'1'
          },
          {
            name:'特种',
            value:'5'
          },
        ],
        idList:[],
        idValue:'',
        upUrl:myHttp.uploadFile,
        uploadHead: {
          //上传接口header
          accessToken: this.$store.state.token
        },
        lock:true
      }
    },
    mounted(){
      //this.getlist()
      this.getTmList()
    },
    methods:{
      getTmList(){
        myHttp.getTeamsByProjectTd({
          projectId:util.session.get('groupId')
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.options1 = res.data.data.teams
          }
        })
      },
      shangchuan(){
        this.lock=false
        let that = this
        if(!this.imageUrl){
          this.imageUrl = 'abc';
        }else if(!this.name){
          this.$message.error('请选择人名')
          that.lock=true
          return
        }
        else if(!this.value){
          this.$message.error('请选择身份证')
          that.lock=true
          return
        }
        else if(!this.date){
          this.$message.error('请选择日期')
          that.lock=true
          return
        }
        else if(!this.value1){
          this.$message.error('请选择班组')
          that.lock=true
          return
        }
        else if(!this.idValue){
          this.$message.error('请选择设备')
          that.lock=true
          return
        }
        let data = {
          faceBase64:this.imageUrl,
          name:this.name,
          uniqueKey:this.value,
          clockTime:this.date,
           teamsId:this.value1
        }
        let imei = this.idValue
        let a = {
          data,
          imei
        }
        console.log(JSON
        .stringify(a))
        myHttp.uploadHisPunchRecords(JSON
        .stringify(a)).then(res=>{
          if(res.data.code==200){
            that.imageUrl=''
            that.name=''
            that.value=''
            that.date=''
            that.value1=''
            that.idValue=''
            this.$message.success(res.data.msg)
          }
          that.lock=true
        })
      },
      handleAvatarSuccess(res, file) {
        console.log(res)
        if(res.code==200){
          this.imageUrl = 'data:image/jpg;base64,' + res.data.base64
        }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        console.log(file)
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        // if (isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        // if (!isLt2M) {
        //   this.$message.error('上传头像图片大小不能超过 2MB!');
        // }
        return true;
      },
      getMachineList(){
        myHttp.getMachineList({
          projectId:util.session.get('groupId'),
          status:this.type
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.idList = res.data.data.pageInfo||[]
          }
        })
      },
      typeCha(){
        this.getMachineList()
      },
      dateCha(){
        console.log(this.date)
      },
      dataCha(e){
        console.log(e,'123')
        this.options.forEach(item=>{
          if(item.idcard==e){
            console.log(item.name)
            this.name=item.name
          }
        })
      },
      teamsChange(e){
        let that = this;
        that.getlist();
        this.options.forEach(item=>{
          if(item.idcard==e){
            console.log(item.name)
            this.name=item.name
          }
        })
      },
      getlist(){
        let that = this;
        myHttp.getProjectPersonByProjectIdAndTeamsId({
          projectId:util.session.get('groupId'),
          teamsId:that.value1,
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.options = res.data.data.projectPersons
          }
        })
      },
    }
  }
</script>

<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 3px solid;
    border-radius: 6px
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.formBox{
  width: 100%;
  height: 100%;
  padding: .4688vw;
}
.cont{
  padding: .5208vw;
  width: 100%;
  height: 100%;
  border-radius: .4167vw;
  background-color: #fff;
}
.item{
  margin-bottom: 1.0417vw;
  display: flex;
  justify-content: start;
  align-items: center;
}
.item>.lable{
  font-size: .8333vw;
  width:80px;
  text-align: start;
}
.input{
  width: 200px;
}
</style>